/**
 * @file        src/components/PageHead.jsx
 * @description Standard page header (title + subtitle + right-side actions).
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
export default function PageHead({ title, subtitle, actions }) {
  return (
    <div className="page-head">
      <div>
        <h1 className="title">{title}</h1>
        {subtitle ? <p className="muted">{subtitle}</p> : null}
      </div>
      {actions ? <div className="head-btns">{actions}</div> : null}
    </div>
  );
}
